import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/swiper-bundle.css';
import { Pagination, Autoplay } from "swiper/modules";
import teamImg1 from "./../../public/images/team-image/prasad.jpg";
import teamImg2 from "./../../public/images/team-image/swetha.PNG";


const teamData = [
  {
    name: "Manchikanti VRV Prasad",
    role: "CEO & Founder",
    imgSrc: teamImg1,
  },
  
  {
    name: "Swetha",
    role: "Director/Head Operations",
    imgSrc: teamImg2,
  },
  
];

const Team = () => {

  return (
    <>
      <div className="team-area ptb-80 bg-f9f6f6 container" id="team">
        <div className="container">
          <div className="section-title">
            <h2>Our Awesome Team</h2>
            <div className="bar"></div>
            <p>
              Unlocking Potential, Delivering Excellence: Together, We Make IT Happen!
            </p>
          </div>
        </div>

        {/* <Swiper
          spaceBetween={30}
          pagination={{
            clickable: true,
          }}
          autoplay={{
            delay: 5000,
            pauseOnMouseEnter: true,
          }}
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            576: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
            1200: {
              slidesPerView: 4,
            },
            1500: {
              slidesPerView: 5,
            },
          }}
          modules={[Pagination, Autoplay]}
          className="team-slider"
        >
          <SwiperSlide>
            <div className="single-team">
              <div className="team-image">
                <img
                  src={teamImg1}
                  alt="image"
                  width={125}
                  height={125}
                />
              </div>

              <div className="team-content">
                <div className="team-info">
                  <h3>Manchikanti VRV Prasad</h3>
                  <span>CEO & Founder</span>
                </div>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="single-team">
              <div className="team-image">
                <img
                  src={teamImg8}
                  alt="image"
                  width={125}
                  height={125}
                />
              </div>

              <div className="team-content">
                <div className="team-info">
                  <h3>Naveen Andey</h3>
                  <span>Director - Customer Success</span>
                </div>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="single-team">
              <div className="team-image">
                <img
                  src={teamImg2}
                  alt="image"
                  width={125}
                  height={125}
                />
              </div>

              <div className="team-content">
                <div className="team-info">
                  <h3>Swetha</h3>
                  <span>Director/Head Operations</span>
                </div>
              </div>
            </div>
          </SwiperSlide>
        

          <SwiperSlide>
            <div className="single-team">
              <div className="team-image">
                <img
                  src={teamImg3}
                  alt="image"
                  width={125}
                  height={125}
                />
              </div>

              <div className="team-content">
                <div className="team-info">
                  <h3>Kommana Vikas</h3>
                  <span>Software Developer</span>
                </div>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="single-team">
              <div className="team-image">
                <img
                  src={teamImg4}
                  alt="image"
                  width={125}
                  height={125}
                />
              </div>

              <div className="team-content">
                <div className="team-info">
                  <h3>Ankit Kumar</h3>
                  <span>Software Developer</span>
                </div>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="single-team">
              <div className="team-image">
                <img
                  src={teamImg6}
                  alt="image"
                  width={125}
                  height={125}
                />
              </div>

              <div className="team-content">
                <div className="team-info">
                  <h3>Satish T</h3>
                  <span>Software Developer</span>
                </div>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="single-team">
              <div className="team-image">
                <img
                  src={Niharika}
                  alt="image"
                  width={125}
                  height={125}
                />
              </div>

              <div className="team-content">
                <div className="team-info">
                  <h3>Helen Niharika N</h3>
                  <span>Software Developer</span>
                </div>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="single-team">
              <div className="team-image">
                <img
                  src={Sunil}
                  alt="image"
                  width={125}
                  height={125}
                />
              </div>

              <div className="team-content">
                <div className="team-info">
                  <h3>Sunil Kumar K</h3>
                  <span>Software Developer</span>
                </div>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="single-team">
              <div className="team-image">
                <img
                  src={teamImg5}
                  alt="image"
                  width={125}
                  height={125}
                />
              </div>

              <div className="team-content">
                <div className="team-info">
                  <h3>Saikiran</h3>
                  <span>Digital Marketing Executive</span>
                </div>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="single-team">
              <div className="team-image">
                <img
                  src={teamImgUha}
                  alt="image"
                  width={125}
                  height={125}
                />
              </div>

              <div className="team-content">
                <div className="team-info">
                  <h3>K Sai Uha</h3>
                  <span>BDE</span>
                </div>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="single-team">
              <div className="team-image">
                <img
                  src={teamImg7}
                  alt="image"
                  width={125}
                  height={125}
                />
              </div>

              <div className="team-content">
                <div className="team-info">
                  <h3>Sai Kumar</h3>
                  <span>BDE</span>
                </div>
              </div>
            </div>
          </SwiperSlide>


        </Swiper> */}

<Swiper
        spaceBetween={30}
        pagination={{ clickable: true }}
        autoplay={{ delay: 5000, pauseOnMouseEnter: true }}
        breakpoints={{
          0: { slidesPerView: 1 },
          576: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
          1200: { slidesPerView: 4 },
          1500: { slidesPerView: 5 },
        }}
        modules={[Pagination, Autoplay]}
        className="team-slider"
      >
        {teamData.map((member, index) => (
          <SwiperSlide key={index}>
            <div className="single-team">
              <div className="team-image">
                <img
                  src={member.imgSrc}
                  alt={`${member.name}`}
                  width={125}
                  height={125}
                />
              </div>
              <div className="team-content">
                <div className="team-info">
                  <h3>{member.name}</h3>
                  <span>{member.role}</span>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      </div>
    </>
  );
};

export default Team;
